<div class="dialog-content-wrapper" *ngIf="esModal">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >OOTT - {{ idOOTT }}</span
            >
            <button
                style="float: right"
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <app-ficha-orden-trabajo
            *ngIf="detalleOOTT"
            [detalleOOTT]="detalleOOTT"
            (verContratista)="verContratista($event)"
            (verAvanceTrabajo)="verAvance($event)"
            (recibirRechazarOOTT)="recibirRechazar($event)"
            (anularOOTTEvent)="anularOOTT($event)"
            (anularTrabajoEvent)="anularTrabajo($event)"
            (abrirListadoContratistas)="
                abrirDialogInvitacionContratistas($event)
            "
            (evaluarTrabajo)="evaluar($event)"
            (corregirObservaciones)="corregir($event)"
            (informaPago)="informarPago($event)"
            (verPersonalApoyoEvent)="verPersonalApoyo($event)"
            (descargarOOTTEvent)="descargarOOTT($event)"
            (verInvitacionesEvent)="verInvitaciones($event)"
        ></app-ficha-orden-trabajo>
    </mat-dialog-content>

    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-raised-button color="accent" mat-dialog-close>
            Cerrar
        </button>
    </mat-dialog-actions>
</div>

<div class="page-layout simple fullwidth" *ngIf="!esModal">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="row" fxLayoutAlign="start center">
            <button
                mat-icon-button
                class="mr-0 mr-sm-16"
                [routerLink]="'/ordenes-de-trabajo'"
            >
                <mat-icon>arrow_back</mat-icon>
            </button>

            <div
                fxLayout="column"
                fxLayoutAlign="start start"
                [@animate]="{
                    value: '*',
                    params: { delay: '100ms', x: '-25px' }
                }"
            >
                <div class="h2">OOTT - {{ idOOTT }}</div>

                <div class="subtitle secondary-text">
                    <span>Detalle</span>
                </div>
            </div>
        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->

    <div class="center p-24 pb-56" fusePerfectScrollbar>
        <div class="content">
            <app-ficha-orden-trabajo
                *ngIf="detalleOOTT"
                [detalleOOTT]="detalleOOTT"
                (verContratista)="verContratista($event)"
                (verAvanceTrabajo)="verAvance($event)"
                (recibirRechazarOOTT)="recibirRechazar($event)"
                (anularOOTTEvent)="anularOOTT($event)"
                (anularTrabajoEvent)="anularTrabajo($event)"
                (abrirListadoContratistas)="
                    abrirDialogInvitacionContratistas($event)
                "
                (evaluarTrabajo)="evaluar($event)"
                (corregirObservaciones)="corregir($event)"
                (informaPago)="informarPago($event)"
                (verPersonalApoyoEvent)="verPersonalApoyo($event)"
                (descargarOOTTEvent)="descargarOOTT($event)"
                (verInvitacionesEvent)="verInvitaciones($event)"
            ></app-ficha-orden-trabajo>
        </div>
    </div>

    <!-- / CONTENT -->
</div>
